import { z } from 'zod';
import { AIJobIdSchema, AIModelSchema } from './jobs.schema';
import { AIProviderIdSchema } from './providers.schema';

// Extended Job Status (adds 'cancelled')
export const AIJobStatusExtendedSchema = z.enum([
  'pending',
  'processing',
  'completed',
  'failed',
  'cancelled',
]);
export type AIJobStatusExtended = z.infer<typeof AIJobStatusExtendedSchema>;

// AI Response (uses existing schemas from jobs and providers)
export const AIResponseSchema = z.object({
  id: AIJobIdSchema,
  status: AIJobStatusExtendedSchema,
  result: z.object({
    text: z.string().optional(),
    imageUrl: z.string().optional(),
  }).optional(),
  error: z.string().optional(),
  provider: AIProviderIdSchema,
  model: AIModelSchema,
  createdAt: z.string(),
  completedAt: z.string().optional(),
  metadata: z.record(z.string(), z.any()).optional(),
});
export type AIResponse = z.infer<typeof AIResponseSchema>;
